import {generateFullUrl} from "services/utils/utils";

export const Speaker = {
    fromServer: (data) => {
        return {
            ...data,
            avatar: generateFullUrl(data.avatar)
        }
    }
}